import { render, staticRenderFns } from "./RecentSearch.vue?vue&type=template&id=59751a71&scoped=true&"
import script from "./RecentSearch.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./RecentSearch.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./RecentSearch.vue?vue&type=style&index=0&id=59751a71&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59751a71",
  null
  
)

export default component.exports